import Dialog from './Dialog';
import { en } from '../../locales/en';
import { MissionLogsCard } from '../../pages/dashboard/vehicle-panel/MissionLogsCard';
import type { MissionId } from '../../types/gcs/mission';
import type { VehicleId } from '../../types/gcs/vehicle';
import { getShortVehicleId } from '../../utils/formatters';

interface MissionLogsDialogProps {
  gcsId: string;
  vehicleId: VehicleId;
  missionId: MissionId;
  onClose: () => void;
}

function MissionLogsDialog({ gcsId, vehicleId, missionId, onClose }: MissionLogsDialogProps) {
  const vehicleLabel = getShortVehicleId(vehicleId);

  const title = vehicleLabel ? `${en.vehicleMissionLabel.vehiclePrefix} ${vehicleLabel}` : '';

  return (
    <Dialog title={en.missionLogsDialog.title} onClose={onClose}>
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <MissionLogsCard gcsId={gcsId} missionId={missionId} title={title} />
      </div>
    </Dialog>
  );
}

export default MissionLogsDialog;
